"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["photos", "breakpoints", "defaultContainerWidth"],
    _excluded2 = ["spacing", "padding", "columns"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { jsx } from "react/jsx-runtime";
import { useMemo, forwardRef } from "react";
import { useContainerWidth } from "./hooks.js";
import StaticPhotoAlbum from "../static/index.js";
import resolveMasonryProps from "./masonryProps.js";
import computeMasonryLayout from "../layouts/masonry.js";

function MasonryPhotoAlbum(_ref, ref) {
  var photos = _ref.photos,
      breakpoints = _ref.breakpoints,
      defaultContainerWidth = _ref.defaultContainerWidth,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContainerWidth = useContainerWidth(ref, breakpoints, defaultContainerWidth),
      containerRef = _useContainerWidth.containerRef,
      containerWidth = _useContainerWidth.containerWidth;

  var _resolveMasonryProps = resolveMasonryProps(containerWidth, _objectSpread({
    photos: photos
  }, rest)),
      spacing = _resolveMasonryProps.spacing,
      padding = _resolveMasonryProps.padding,
      columns = _resolveMasonryProps.columns,
      restProps = _objectWithoutProperties(_resolveMasonryProps, _excluded2);

  var model = useMemo(function () {
    return containerWidth !== void 0 && spacing !== void 0 && padding !== void 0 && columns !== void 0 ? computeMasonryLayout(photos, spacing, padding, containerWidth, columns) : void 0;
  }, [photos, spacing, padding, containerWidth, columns]);
  return jsx(StaticPhotoAlbum, _objectSpread({
    layout: "masonry",
    ref: containerRef,
    model: model
  }, restProps));
}

var MasonryPhotoAlbum$1 = forwardRef(MasonryPhotoAlbum);
export { MasonryPhotoAlbum$1 as default };